import { ReactNode } from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

export type SortDirection = 'asc' | 'desc' | null;

interface SortableHeaderProps {
  label: ReactNode;
  sortKey: string;
  currentSortKey: string | null;
  currentSortDirection: SortDirection;
  onSort: (key: string) => void;
  className?: string;
  align?: 'left' | 'center' | 'right';
  title?: string;
  dataTutorial?: string;
  suffix?: ReactNode;
}

export default function SortableHeader({
  label,
  sortKey,
  currentSortKey,
  currentSortDirection,
  onSort,
  className = '',
  align = 'left',
  title,
  dataTutorial,
  suffix,
}: SortableHeaderProps) {
  const isActive = currentSortKey === sortKey;
  const isAsc = isActive && currentSortDirection === 'asc';
  const isDesc = isActive && currentSortDirection === 'desc';

  const alignClass = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';
  const tooltipText = title || (typeof label === 'string' ? `Trier par ${label}` : 'Trier');

  return (
    <th className={`pb-3 font-medium ${className}`} data-tutorial={dataTutorial}>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onSort(sortKey)}
          className={`flex items-center gap-1 hover:text-gray-700 transition-colors ${alignClass}`}
          title={tooltipText}
        >
          <span className={align === 'right' ? 'order-1' : ''}>{label}</span>
          <span className={`flex items-center gap-0 ${align === 'right' ? 'order-2' : ''}`}>
            <ArrowUp
              className={`w-3 h-3 ${isDesc ? 'text-gray-900' : 'text-gray-300'}`}
            />
            <ArrowDown
              className={`w-3 h-3 ${isAsc ? 'text-gray-900' : 'text-gray-300'}`}
            />
          </span>
        </button>
        {suffix}
      </div>
    </th>
  );
}
